import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  fuelingUnit: string;
  commodityDetail: CommodityDetail;
};

const FuelingMonthSummaryHeader = ({fuelingUnit, commodityDetail }: Props) => {
  // transaltions
  const tLabels = useTranslation("fueling\\fueling").t;

  // render
  return (
    <div className="d-none d-sm-block px-3 mb-2 text-muted font-weight-bold mr-5">
      <div className="row no-gutters align-items-center">
        <div className="col-sm text-truncate">
          {tLabels("fuelingMonthSummaryHeader.month")}
        </div>
        <div className="col-sm text-sm-center">
          {tLabels(`fuelingMonthSummaryHeader.fuelingSum.${commodityDetail}`)}
          <small> [{fuelingUnit}]</small>
        </div>
        <div className="col-sm text-sm-center">
          {tLabels(`fuelingMonthSummaryHeader.fuelingCount.${commodityDetail}`)}
        </div>
        <div className="col-sm text-sm-center">
          {tLabels("fuelingMonthSummaryHeader.totalAmount")}
        </div>
      </div>
    </div>
  );
};

export default FuelingMonthSummaryHeader;
